/**
 * Which game slugs have something to open.
 *  - 'survey' and 'carbon-calculator' are built into the app.
 *  - Any other game is a standalone HTML file dropped into src/assets/games/
 *    and named after its slug, e.g. water-lab.html, oil-mining.html,
 *    would-you-rather.html. Until the file exists the game shows "coming soon".
 */
const htmlGames = import.meta.glob('/src/assets/games/*.html', {
  query: '?raw',
  import: 'default',
}) as Record<string, () => Promise<string>>;

export const BUILT_IN_GAMES = ['survey', 'carbon-calculator'] as const;

export const htmlGameLoader = (slug: string) => htmlGames[`/src/assets/games/${slug}.html`];

export const hasGameFile = (slug: string) =>
  (BUILT_IN_GAMES as readonly string[]).includes(slug) || Boolean(htmlGameLoader(slug));
